import React, { useEffect, useMemo, useState, useCallback } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CommonDataTable from "../../../components/CommonDataTable";
import { getItemPricingList } from "../../../services/skuItem/skuItem";
import { width } from "@mui/system";
const rawColumns = [
  { field: "itemCode", headerName: "Item Code", width: 150 },
  { field: "itemName", headerName: "Item Name", width: 180 },
  { field: "retailPrice", headerName: "Retail Price(Rs/-)", width: 140 },
  { field: "hsnCode", headerName: "HsnCode", width: 140 },
  { field: 'hsnDescription', headerName: "HsnDescription", width: 140 },
  { field: "customerDiscount", headerName: "Customer Discount %", width: 190 },
  { field: "subscriptionDiscount", headerName: "Subscription Discount %", width: 220 },
  { field: "onPromotion", headerName: "On Promotion", width: 140 },
  { field: "promotionLabel", headerName: "Promotion Label", width: 170 },
  { field: "promotionalPrice", headerName: "Promotional Price", width: 190 },
  { field: "sellPrice", headerName: "Sell Price(Rs/-)", width: 140 },
];

export default function SkuPricingListing({
  onCreateClick,
  refreshKey,
  onView,
  onEdit,
}) {
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [menuRow, setMenuRow] = useState(null);
  const [tableRows, setTableRows] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  /* ---------------- LOAD LIST ---------------- */
  const loadList = useCallback(async (page, pageSize) => {
    try {

      const res = await getItemPricingList(page, pageSize);
      if (res && res?.data.length) {
        const formatted = res.data.map((item) => ({
          itemCode: item.itemCode.itemCode,
          itemName: item.itemCode.itemName,
          retailPrice: item.retailPrice,
          hsnCode: item.hsnCode.hsnCode,
          hsnDescription: item.hsnCode.hsnDescription,
          customerDiscount: item.custDiscount.custDiscount || 0,
          subscriptionDiscount: item.subscription.subscriptionDiscount || 0,
          onPromotion: item.promotion.onPromotion ? "Yes" : "No",
          promotionLabel: item.promotion.promotionLabel || "-",
          promotionalPrice: item.promotion.promotionPrice || "-",
          sellPrice: item.sellPrice,
          __original: item,
          id: item._id,
        }));

        setTableRows(formatted);
        setTotalCount(res.pagination.totalRecords);
      } else {
        setTableRows([]);
        setTotalCount(0);
      }
    } catch (err) {
      console.error(err);
      setTableRows([]);
      setTotalCount(0);
    }
  }, []);

  useEffect(() => {
    loadList(page, pageSize);
  }, [refreshKey, page, pageSize, loadList]);

  /* ---------------- MENU HANDLING ---------------- */
  const handleOpenMenu = (e, row) => {
    e.stopPropagation();
    setMenuAnchorEl(e.currentTarget);
    setMenuRow(row);
  };

  const handleCloseMenu = () => {
    setMenuAnchorEl(null);
    setMenuRow(null);
  };

  const actionColumn = {
    field: "__actions",
    headerName: "",
    width: 80,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    renderCell: (params) => (
      <IconButton
        size="small"
        onClick={(e) => handleOpenMenu(e, params.row)}
      >
        <MoreVertIcon fontSize="small" />
      </IconButton>
    ),
  };

  const allPossibleColumns = useMemo(
    () => [actionColumn, ...rawColumns],
    []
  );

  const initialVisible = useMemo(
    () => allPossibleColumns.map((c) => c.field),
    [allPossibleColumns]
  );

  return (
    <>
      <CommonDataTable
        allPossibleColumns={allPossibleColumns}
        initialVisible={initialVisible}
        initialRows={tableRows}
        height={520}
        rowsPerPageOptions={[10, 25, 50, 100]}
        exportImportPath="PricingMaster"
        showCreateButton
        createButtonText="Create Pricing"
        createButtonIcon="bi-plus-lg"
        onCreateClick={onCreateClick}
        createButtonVariant="contained"
        createButtonColor="primary"
        page={page}
        pageSize={pageSize}
        rowCount={totalCount}
        onPageChange={(newPage) => setPage(newPage)}
        onPageSizeChange={(newSize) => {
          setPageSize(newSize);
          setPage(0);
        }}
        onDataRefresh={async ({
          filters = [],
          page: p = 0,
          pageSize: ps = pageSize,
        } = {}) => {
          console.log("Pricing refresh:", { filters, p, ps });
        }}
      />

      <Menu
        open={!!menuAnchorEl}
        anchorEl={menuAnchorEl}
        onClose={handleCloseMenu}
      >
        <MenuItem onClick={() => onView(menuRow?.__original)}>
          <i className="bi bi-eye me-2" /> View
        </MenuItem>
        {/* <MenuItem onClick={() => onEdit(menuRow?.__original)}>
          <i className="bi bi-pencil me-2" /> Edit
        </MenuItem> */}
      </Menu>
    </>
  );
}
